export const LIGHT_RAYS_VERTEX = `
attribute vec2 position;
void main() {
  gl_Position = vec4(position, 0.0, 1.0);
}`;

export const LIGHT_RAYS_FRAGMENT = `
precision highp float;

uniform float iTime;
uniform vec2 iResolution;
uniform vec2 rayPos;
uniform vec2 rayDir;
uniform float raysSpeed;
uniform float lightSpread;
uniform float rayLength;
uniform float fadeDistance;
uniform vec2 mousePos;
uniform float mouseInfluence;

float rayStrength(vec2 source, vec2 direction, vec2 coord, float seedA, float seedB, float speed) {
  vec2 toCoord = coord - source;
  float cosAngle = dot(normalize(toCoord), direction);
  float spread = pow(max(cosAngle, 0.0), 1.0 / max(lightSpread, 0.001));
  float distance = length(toCoord);
  float maxDistance = iResolution.x * rayLength;
  float lengthFalloff = clamp((maxDistance - distance) / maxDistance, 0.0, 1.0);
  float fade = clamp((iResolution.x * fadeDistance - distance) / (iResolution.x * fadeDistance), 0.5, 1.0);
  float base = clamp(
    (0.45 + 0.15 * sin(cosAngle * seedA + iTime * speed)) +
    (0.3 + 0.2 * cos(-cosAngle * seedB + iTime * speed)),
    0.0, 1.0
  );
  return base * lengthFalloff * fade * spread;
}

void main() {
  vec2 coord = vec2(gl_FragCoord.x, iResolution.y - gl_FragCoord.y);
  vec2 mouseDirection = normalize(mousePos * iResolution - rayPos);
  vec2 direction = normalize(mix(rayDir, mouseDirection, mouseInfluence));
  vec4 color = vec4(1.0) * rayStrength(rayPos, direction, coord, 36.2214, 21.11349, 1.5 * raysSpeed) * 0.5
             + vec4(1.0) * rayStrength(rayPos, direction, coord, 22.3991, 18.0234, 1.1 * raysSpeed) * 0.4;
  float brightness = 1.0 - coord.y / iResolution.y;
  color.rgb *= 0.35 + brightness * 0.65;
  gl_FragColor = color;
}`;
